/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface JumboPostazureaccountsPostAzureAccountsRequestBody
 */
export interface JumboPostazureaccountsPostAzureAccountsRequestBody {
    /**
     * 
     * @type {string}
     * @memberof JumboPostazureaccountsPostAzureAccountsRequestBody
     */
    clientID: string;
    /**
     * 
     * @type {string}
     * @memberof JumboPostazureaccountsPostAzureAccountsRequestBody
     */
    clientSecret: string;
    /**
     * 
     * @type {string}
     * @memberof JumboPostazureaccountsPostAzureAccountsRequestBody
     */
    tenantID: string;
}

/**
 * Check if a given object implements the JumboPostazureaccountsPostAzureAccountsRequestBody interface.
 */
export function instanceOfJumboPostazureaccountsPostAzureAccountsRequestBody(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "clientID" in value;
    isInstance = isInstance && "clientSecret" in value;
    isInstance = isInstance && "tenantID" in value;

    return isInstance;
}

export function JumboPostazureaccountsPostAzureAccountsRequestBodyFromJSON(json: any): JumboPostazureaccountsPostAzureAccountsRequestBody {
    return JumboPostazureaccountsPostAzureAccountsRequestBodyFromJSONTyped(json, false);
}

export function JumboPostazureaccountsPostAzureAccountsRequestBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): JumboPostazureaccountsPostAzureAccountsRequestBody {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'clientID': json['clientID'],
        'clientSecret': json['clientSecret'],
        'tenantID': json['tenantID'],
    };
}

export function JumboPostazureaccountsPostAzureAccountsRequestBodyToJSON(value?: JumboPostazureaccountsPostAzureAccountsRequestBody | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'clientID': value.clientID,
        'clientSecret': value.clientSecret,
        'tenantID': value.tenantID,
    };
}

